export enum EPage {
  BLANK = 'BLANK',
  BUY_RECHARGES = 'BuyRecharges',
  GENERIC_ERROR = 'GenericError',
  GENERATE_FOLIO = 'GenerateFolio',
  HISTORY = 'History',
  INTERNET_ON_DEMAND = 'InternetOnDemand',
  INVOICE = 'Invoice',
  LANDING = 'Landing',
  LATE_PAYMENT = 'LatePayment',
  MAINTENANCE = 'Maintenance',
  MICROCREDITS = 'Microcredits',
  NOT_FOUND = 'NotFound',
  PACKAGES = 'Packages',
  PROFILE = 'Profile',
  PAYMENT_FORM = 'PaymentForm',
  RESULT = 'Result',
  ROOT = 'Root',
  SEND_RECHARGES = 'SendRecharges',
  SHORT_LINK = 'ShortLink',
  TERMS = 'Terms',
  TURN_ON_3G = 'TurnOn3g',
  PROMOTIONS = 'Promotions',
  EXIT = 'Exit'
}

export enum EMcweb {
  MCW = 'MCW',
  MCW_TERMS = 'MCWTerms',
  OK_RESULT = 'OKResult',
  CONTACT = 'Contact'
}
